export default {
    PtSelectLanguage: {
        language: 'Language',
    },
};
